import { render, staticRenderFns } from "./introduction-process.vue?vue&type=template&id=68d9f249&scoped=true&"
import script from "./introduction-process.vue?vue&type=script&lang=js&"
export * from "./introduction-process.vue?vue&type=script&lang=js&"
import style0 from "./introduction-process.vue?vue&type=style&index=0&id=68d9f249&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d9f249",
  null
  
)

export default component.exports